import { create } from 'zustand';

export const useMessageStore = create((set) => ({
  // Messages
  messages: [],
  quotedMessages: [],
  messagesPage: 1,
  messageOffset: 0,
  messageAccess: {
    currentSectorRestricted: false,
    currentSectorName: null,
  },
  hasMoreMessages: true,
  isMessagesLoading: false,
  messagesError: null,
  isMessageSendingError: false,
  isStartingNewChatTemplate: false,

  // Input
  textMessage: '',
  searchMessageValue: '',
  messageToScroll: null,
  isAComment: false,

  // Scheduled
  scheduledMessages: [],
  chatMarkedAsUnread: false,

  // Tracking previous chat for message fetch logic
  previousSenderChat: null,
  previousFromMsgChat: null,

  // Official API Templates
  officialApiTemplates: {
    open: false,
    loading: false,
    data: [],
    selectedToSend: null,
    selectedToSchedule: null,
    isCurrentChatFromOfficialApi: false,
    isOfficialApiMessageExpired: false,
    isOfficialApiTemplateSended: false,
    isCreatingNewTemplate: false,
    isDeletingSelectedTemplate: false,
  },

  // Audio transcription
  audioTranscription: {
    showAudioTranscription: false,
    isLoadingTranscription: false,
    transcriptionText: [],
  },

  // Setters
  setMessages: (msgsOrFn) => set((state) => ({
    messages: typeof msgsOrFn === 'function' ? msgsOrFn(state.messages) : msgsOrFn,
  })),
  setQuotedMessages: (msgsOrFn) => set((state) => ({
    quotedMessages: typeof msgsOrFn === 'function' ? msgsOrFn(state.quotedMessages) : msgsOrFn,
  })),
  setMessagesPage: (pageOrFn) => set((state) => ({
    messagesPage: typeof pageOrFn === 'function'
      ? pageOrFn(state.messagesPage)
      : pageOrFn,
  })),
  setMessageOffset: (offset) => set({ messageOffset: offset }),
  setMessageAccess: (access = {}) => set({
    messageAccess: {
      currentSectorRestricted: Boolean(access.currentSectorRestricted),
      currentSectorName: access.currentSectorName || null,
    },
  }),
  setHasMoreMessages: (has) => set({ hasMoreMessages: has }),
  setIsMessagesLoading: (loading) => set({ isMessagesLoading: loading }),
  setMessagesError: (error) => set({ messagesError: error }),
  setIsMessageSendingError: (error) => set({ isMessageSendingError: error }),
  setIsStartingNewChatTemplate: (loading) => set({ isStartingNewChatTemplate: loading }),
  setTextMessage: (textOrFn) => set((state) => ({
    textMessage: typeof textOrFn === 'function'
      ? textOrFn(state.textMessage)
      : textOrFn,
  })),
  setSearchMessageValue: (value) => set({ searchMessageValue: value }),
  setMessageToScroll: (msg) => set({ messageToScroll: msg }),
  setIsAComment: (isCommentOrFn) => set((state) => ({
    isAComment: typeof isCommentOrFn === 'function'
      ? isCommentOrFn(state.isAComment)
      : isCommentOrFn,
  })),
  setScheduledMessages: (msgsOrFn) => set((state) => ({
    scheduledMessages: typeof msgsOrFn === 'function'
      ? msgsOrFn(state.scheduledMessages)
      : msgsOrFn,
  })),
  setChatMarkedAsUnread: (unread) => set({ chatMarkedAsUnread: unread }),
  setPreviousSenderChat: (sender) => set({ previousSenderChat: sender }),
  setPreviousFromMsgChat: (fromMsg) => set({ previousFromMsgChat: fromMsg }),
  setOfficialApiTemplates: (templatesOrFn) => set((state) => ({
    officialApiTemplates: typeof templatesOrFn === 'function'
      ? templatesOrFn(state.officialApiTemplates)
      : templatesOrFn,
  })),
  setAudioTranscription: (transcriptionOrFn) => set((state) => ({
    audioTranscription: typeof transcriptionOrFn === 'function'
      ? transcriptionOrFn(state.audioTranscription)
      : transcriptionOrFn,
  })),
}));
